module.exports = __webpack_public_path__ + "static/DEV1-adf77c13b644de5010188e53fb11e4cd.jpg";